"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'user.form.language.label': 'Lingua',
    'user.form.language.placeholder': 'Seleziona lingua',
    'user.form.userGroup.label': 'Gruppo di Utenti',
    'user.form.userGroup.placeholder': 'Seleziona gruppo di utenti',
    'user.form.userGroup.show': 'Mostra Gruppi di Utenti',
    'user.form.userGroup.add': 'Aggiungi nuovo gruppo di utenti',
    'user.form.userGroup.search_placeholder': 'Cerca gruppi di utenti...',
    'user.form.title.edit': 'Modifica Utente',
    'user.form.title.add': 'Aggiungi Utente',
    'user.form.back': 'Indietro',
    'user.form.name.label': 'Nome',
    'user.form.name.placeholder': 'Mario',
    'user.form.last_name.label': 'Cognome',
    'user.form.last_name.placeholder': 'Rossi',
    'user.form.username.label': 'Login',
    'user.form.username.placeholder': 'mariorossi',
    'user.form.email.label': 'Email',
    'user.form.email.placeholder': 'email@indirizzo.com',
    'user.form.password.label': 'Password',
    'user.form.password.new.label': 'Nuova Password (lasciare vuoto per mantenere attuale)',
    'user.form.password.placeholder': 'Password',
    'user.form.password.repeat.label': 'Ripeti Password',
    'user.form.password.repeat.new.label': 'Ripeti Password (lasciare vuoto per mantenere attuale)',
    'user.form.password.repeat.placeholder': 'Ripeti Password',
    'user.form.role.label': 'Ruolo',
    'user.form.role.placeholder': 'Seleziona ruolo',
    'user.form.active.label': 'Attivo',
    'user.form.companies.label': 'Aziende assegnate',
    'user.form.companies.placeholder': 'Seleziona aziende',
    'user.form.company.label': 'Azienda',
    'user.form.company.placeholder': 'Seleziona un\'azienda...',
    'user.form.submit.update': 'Aggiorna Utente',
    'user.form.submit.create': 'Crea Utente',
    'user.form.acl.loadError': 'Errore nel caricamento metadati ACL:',
    'user.form.load.debug': 'Caricamento utente:',
    'user.form.load.error': 'Errore nel caricamento utente',
    'user.form.submit.updateError': 'Errore nell\'aggiornamento utente',
    'user.form.submit.createError': 'Errore nella creazione utente',
    'user.form.submit.updateSuccess': 'Utente aggiornato con successo',
    'user.form.submit.createSuccess': 'Utente creato con successo',
    'user.form.preview.title': 'Anteprima Accesso',
    'user.form.preview.selectedGroup': 'Gruppo Selezionato',
    'user.form.preview.permissions': 'Permessi',
    'user.form.preview.selectGroup': 'Seleziona un gruppo utenti per vedere i permessi di accesso',
    'user.form.preview.noAccess': 'Nessun permesso di accesso disponibile',
    'user.form.error.userGroup_required': 'La selezione del gruppo utenti è obbligatoria',
};
